import * as React from 'react';
import ReactHtmlParser from 'react-html-parser';
import ESI from 'nodesi';
import { IWithSpidContext, withSpidContext } from '@snoam/mono-spid';
import { getCoreHeaderStyleFromClientName } from '../fastflowUtils';
import Header from './Header';
import { BackgroundLoader } from '@snoam/mono-background-loader';
import { initCoreHeader } from '@snoam/mono-core-header-session-adapter';

const esi = new ESI({});

export interface ICoreHeaderProps extends IWithSpidContext {
  clientName: string;
  clientShortHandName: string;
  hostname: string;
}

export interface ICoreHeaderState {
  header: any;
}

/* tslint:disable*/
class CoreHeader extends React.Component<ICoreHeaderProps, ICoreHeaderState> {
  public static displayName = 'CoreHeader';

  constructor(props) {
    super(props);

    this.state = {
      header: null,
    };
  }

  /**
   * Creates all the necessary scripts for running core-header
   * this includes paywall scripts and custom javascript to make the menu animated etc.
   * */
  public makeScript(
    options: { [k: string]: string },
    body?: string,
    onload?: () => void,
  ) {
    const script = document.createElement('script');
    Object.keys(options).forEach((k) => script.setAttribute(k, options[k]));

    if (body) {
      script.innerText = body;
    }
    document.body.appendChild(script);

    if (options.src && onload) {
      // Handle Script loading
      let done = false;

      // Attach handlers for all browsers
      script.onload = (script as any).onreadystatechange = function () {
        if (
          !done &&
          (!this.readyState ||
            this.readyState === 'loaded' ||
            this.readyState === 'complete')
        ) {
          done = true;
          onload();

          // Handle memory leak in IE
          script.onload = (script as any).onreadystatechange = null;
          if (document.body && script.parentNode) {
            document.body.removeChild(script);
          }
        }
      };
    }
  }

  public componentDidMount() {
    this.buildCoreHeader();
  }

  public buildCoreHeader() {
    // We exclude the MPL (Magsinpluss) from core header, and renders normal FF header.
    if (this.props.clientShortHandName === 'MPL') {
      this.setState({ header: 'MPL' });
    } else {
      const client = getCoreHeaderStyleFromClientName(
        this.props.clientShortHandName.toLowerCase(),
      );
      const { hostname } = this.props;
      this.makeScript({ id: 'spid-jssdk' });

      esi
        .process(
          `
          <esi:include src="https://core-header.schibsted.tech/header?skin=${client}&partial=content" />
          <esi:include src="https://core-header.schibsted.tech/header?skin=${client}&partial=styles" />
        `,
        )
        .then((header) => {
          const headerWithCorrectLogoLink = header.replace(
            /<a class="ch-logo" href="\/">/,
            `<a class=\"ch-logo\" href=\"https://www.${hostname}\">`,
          );
          this.setState({ header: headerWithCorrectLogoLink });
        })
        .catch((e) => console.log(e));

      esi
        .process(
          `
          <esi:include src="https://core-header.schibsted.tech/header?skin=${client}&partial=content" />
          <esi:include src="https://core-header.schibsted.tech/header?skin=${client}&partial=scripts" />
        `,
        )
        .then((scriptTags) => {
          (scriptTags.match(/<script>([^<]+)/gi) || []).forEach(
            (scriptBody) => {
              this.makeScript({}, scriptBody.replace('<script>', ''));
            },
          );
          let match: RegExpExecArray | undefined;
          // match attributes of script tags that have a src attribute
          const regex: RegExp =
            /<script\s+([^>]*src=["'][^>]*)>.*<\/script\s*>/gim;

          while ((match = regex.exec(scriptTags))) {
            const attributes = match[1];
            // match key/value pairs in individual groups
            const r = /([\w\-]+)=(["'])(.*)\2\s*/gm;
            const options = {};
            let m;
            // construct options object with all the attributes of the script tag
            while ((m = r.exec(attributes))) {
              options[m[1]] = m[3];
            }
            this.makeScript(options, '', () => {
              initCoreHeader().then(
                this.props.spidContext.actions.checkLoginStatus,
              );
            });
          }
        });
    }
  }

  public render() {
    const { header } = this.state;

    if (header !== null && header !== 'MPL') {
      return ReactHtmlParser(header);
    }
    if (header === 'MPL') {
      return <Header />;
    }
    return <BackgroundLoader />;
  }
}

export default withSpidContext<ICoreHeaderProps>(CoreHeader);
